import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute, Outlet } from '@tanstack/react-router';
export const Route = createFileRoute('/org/$organization/$project/$application/settings')({
    component: Component
});
function Component() {
    return /*#__PURE__*/ _jsx(Outlet, {});
}
